<template>
<div class="chapter">
<div class="inner_page">
<p class="break" id="ack"> </p>
<p class="fmh"><span class="epub-b">Acknowledgments</span></p>
<p class="tx">I want to thank my agent, Jacques de Spoelberch, for his continual guidance, and my editor, Daniela Rapp, for her enduring patience.</p>
<p class="tx">I also want to thank Jenny Hancey, Mary Anne Mier, Julia Nichols, and Jenny Ramsey for all their help.</p>
<p class="tx">Last, I want to thank my wife, Marion, and daughter, Jin, for allowing me to be distracted temporarily while I wrote this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?82b138a6